// src/components/planner/modals/GoalModal.tsx

import React, { useState } from 'react';
import { X, Save } from 'lucide-react';

const API_BASE_URL = '/api';

interface GoalModalProps {
    onClose: () => void;
    onSave: () => void;
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const GoalModal: React.FC<GoalModalProps> = ({
    onClose,
    onSave,
    onShowToast
}) => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        type: 'study',
        customType: '',
        color: '#003BD1'
    });

    const colors = [
        '#003BD1', '#2563eb', '#9333ea', '#ea580c',
        '#dc2626', '#10b956', '#ca8a04', '#6B7280'
    ];

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!formData.title.trim()) {
            onShowToast('Preencha o título da meta', 'error');
            return;
        }

        try {
            const token = localStorage.getItem('accessToken');
            const response = await fetch(`${API_BASE_URL}/planner/goals`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    ...formData,
                    type: formData.type === 'other' ? formData.customType : formData.type
                })
            });

            if (response.ok) {
                onShowToast('Meta criada!', 'success');
                onSave();
            } else {
                onShowToast('Erro ao criar meta', 'error');
            }
        } catch (error) {
            onShowToast('Erro ao criar meta', 'error');
        }
    };

    return (
        <div className="plnr-modal-overlay" onClick={onClose}>
            <div className="plnr-modal" onClick={(e) => e.stopPropagation()}>
                <div className="plnr-modal-header">
                    <h3>Nova Meta</h3>
                    <button className="plnr-modal-close" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="plnr-modal-body">
                        <div className="plnr-form-group">
                            <label>Título da meta *</label>
                            <input
                                type="text"
                                value={formData.title}
                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                placeholder="Ex: Finalizar Cardiologia"
                                className="plnr-input"
                                required
                            />
                        </div>

                        <div className="plnr-form-group">
                            <label>Descrição (opcional)</label>
                            <textarea
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                placeholder="Detalhes sobre a meta..."
                                className="plnr-textarea"
                                rows={2}
                            />
                        </div>

                        <div className="plnr-form-group">
                            <label>Tipo de meta</label>
                            <select
                                value={formData.type}
                                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                className="plnr-input"
                            >
                                <option value="study">Estudo</option>
                                <option value="exam">Prova</option>
                                <option value="content">Conteúdo</option>
                                <option value="skill">Habilidade</option>
                                <option value="other">Outro</option>
                            </select>
                        </div>

                        {formData.type === 'other' && (
                            <div className="plnr-form-group">
                                <label>Nome do tipo</label>
                                <input
                                    type="text"
                                    value={formData.customType}
                                    onChange={(e) => setFormData({ ...formData, customType: e.target.value })}
                                    placeholder="Ex: Pesquisa"
                                    className="plnr-input"
                                />
                            </div>
                        )}

                        <div className="plnr-form-group">
                            <label>Cor</label>
                            <div className="plnr-color-grid">
                                {colors.map(color => (
                                    <button
                                        key={color}
                                        type="button"
                                        className={`plnr-color-option ${formData.color === color ? 'active' : ''}`}
                                        style={{ backgroundColor: color }}
                                        onClick={() => setFormData({ ...formData, color })}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="plnr-modal-footer">
                        <button type="button" className="plnr-btn secondary" onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="submit" className="plnr-btn primary">
                            <Save size={16} />
                            Salvar Meta
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default GoalModal;